/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetAllGroupsForDropDown,
    GetKfcOutletsByGroupID,
    GetCustomerOrderConfigurationByGroupID,
    GetProductCategoties,
    GetProductDetails,
    PlaceSpecialOrder,
    GetCustomerOrderDetailsForListing,
    ApproveVPUSpecialOrder,
    RejectVPUSpecialOrder,
    GetSpecialOrdersBySpecialOrderID,
    UpdateSpecialOrder,
    GetProductsByFactoryIDProductcatogeryID,
    GetProductCategotiesForDropDown,
    GetAllBatchDetails,
    GetFreshSKUsDetails,
    GetFreshCutSKUsDetails,
    SaveCustomerOrderDetails,
    GetCustomerOrderDetailsByCustomerOrderID,
    UpdateCustomerOrderDetails,
    DeleteCustomerOrderDetails
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetKfcOutletsByGroupID(groupID) {
    const response = await CommonGet('/api/CustomerOrderPanel/GetKfcOutletsByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetCustomerOrderConfigurationByGroupID(groupID) {
    const response = await CommonGet('/api/CustomerOrderConfiguration/GetOutletByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryID', 'factoryID=' + parseInt(factoryID) + '&productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}


async function PlaceSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/PlaceSpecialOrder', null, data);
    return response;
}

async function GetCustomerOrderDetailsForListing(model) {
    const response = await CommonPost('/api/CustomerOrderPanel/GetCustomerOrderDetailsForListing', null, model);
    return response.data;
}

async function ApproveVPUSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/ApproveVPUSpecialOrder', null, data);
    return response;
}

async function RejectVPUSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/RejectVPUSpecialOrder', null, data);
    return response;
}

async function GetSpecialOrdersBySpecialOrderID(specialOrderID) {
    const response = await CommonGet('/api/SpecialOrder/GetSpecialOrdersBySpecialOrderID', 'specialOrderID=' + parseInt(specialOrderID));
    return response.data;
}

async function UpdateSpecialOrder(data) {
    const response = await CommonPost('/api/SpecialOrder/UpdateSpecialOrder', null, data);
    return response;
}

async function GetProductCategotiesForDropDown() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetailsForDropDown', null);
    return response.data;
}

async function GetAllBatchDetails(productCategoryID) {
    const response = await CommonGet('/api/CustomerOrderPanel/GetAllBatchDetails', 'productCategoryID=' + parseInt(productCategoryID));
    return response.data;
}

async function GetFreshSKUsDetails(productCategoryID) {
    const response = await CommonGet('/api/CustomerOrderPanel/GetFreshSKUsDetails', 'productCategoryID=' + parseInt(productCategoryID));
    return response.data;
}

async function GetFreshCutSKUsDetails(productCategoryID) {
    const response = await CommonGet('/api/CustomerOrderPanel/GetFreshCutSKUsDetails', 'productCategoryID=' + parseInt(productCategoryID));
    return response.data;
}

async function SaveCustomerOrderDetails(data) {
    const response = await CommonPost('/api/CustomerOrderPanel/SaveCustomerOrderDetails', null, data);
    return response;
}

async function GetCustomerOrderDetailsByCustomerOrderID(customerOrderID) {
    const response = await CommonGet('/api/CustomerOrderPanel/GetCustomerOrderDetailsByCustomerOrderID', 'customerOrderID=' + parseInt(customerOrderID));
    return response.data;
}

async function UpdateCustomerOrderDetails(data) {
    const response = await CommonPost('/api/CustomerOrderPanel/UpdateCustomerOrderDetails', null, data);
    return response;
}

async function DeleteCustomerOrderDetails(data) {
    const response = await CommonPost('/api/CustomerOrderPanel/DeleteCustomerOrderDetails', null, data);
    return response;
}